import React from 'react'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useLocation } from 'react-router-dom';

function HomeButton() {
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    return (
        !isHomePage && (<div className='w-[inherit]'>
            <Link to='/'>
                <button className='btn btn-third btn-sm hidden sm:block ml-3'>
                    <FontAwesomeIcon icon={faHome} />
                </button>
            </Link>
        </div>)
    )
}

export default HomeButton
